import { render, staticRenderFns } from "./NumberStatCardComponent.vue?vue&type=template&id=1c0a5ab9&"
import script from "./NumberStatCardComponent.vue?vue&type=script&lang=js&"
export * from "./NumberStatCardComponent.vue?vue&type=script&lang=js&"
import style0 from "./NumberStatCardComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VChip,VIcon,VTooltip})
